//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as jq from "../../../../js/jquery-3.5.1.min";
import * as aos from "../../../../js/aos-2.3.4min";
import * as slick from "../../../../js/slick-1.8.1.min";
import * as dito from "../../../../js/dito";
import portList from "@/pcpage/hr/recruitment/portal/portList";
import commonlist from "@/pcpage/hr/common/commonlist";
import * as auth from "@/utils/auth";
export default {
  extends: commonlist,
  name: "hrIndex",
  components: {
    portList,
  },
  data() {
    return {
      loadRouter: "/portal/portLoad",
    };
  },
  methods: {
    doRowEdit(tableRow) {
      this.$router.push({
        path: this.loadRouter,
        query: {
          uuid: tableRow.uuid,
        },
      });
    },

    async goToPortList() {
      let oQuery = {};
      let routerpath = "/portal/portList";
      this.openWin(routerpath, oQuery);
    },
    openApply(tableRow) {
      let token = auth.getToken();
      if (this.isNotNullOrEmpty(token)) {
        this.checkJobInfo(tableRow.uuid);
      } else {
        this.$router.push({
          path: "/portal/login",
          query: {},
        });
      }
    },
    async checkJobInfo(uuid) {
      //验证该岗位是否未发布
      let checkUrl = "api/api/portalLogin/checkJobInfo";
      let params = {
        uuid: uuid,
      };
      await this.axios
        .post(checkUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            let msg = data.data.msg;
            if (this.isNotNullOrEmpty(msg)) {
              this.$msgDailog.showMsgBox({
                title: msg,
              });
              return;
            }
            this.$router.push({
              path: "/portal/submitResume",
              query: {
                uuid: uuid,
              },
            });
          }
        })
        .catch((error) => console.log(error));
    },
  },
  created() {
    this.listAction = "api/api/getApplyJobList";
    this.queryinfo["hotjob"] = "1";
    this.dopagequery();
  },
  mounted() {
    jq.jq();
    aos.aos();
    slick.slick();
    dito.dito();
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/hrIndex.vue